export default class TimerService {
  private intervalId: ReturnType<typeof setInterval> | null = null;
  private seconds = 0;

  private formatTime(totalSeconds: number): string {
    const minutes = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  }

  public startTimer(): void {
    this.intervalId = setInterval(() => {
      this.seconds = this.seconds + 1
    }, 1000);
  }

  public stopTimer(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  public getTimer(): string {
    return this.formatTime(this.seconds);
  }
}